import { CanAccess } from '@modules/common/components/CanAccess';
import { CustomFilterInfoText } from '@modules/common/components/CustomFilterInfoText';
import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { trackCustomFilterEvents } from '@modules/queryBuilder/helpers';
import { useIsCreateNewFilterEnabled } from '@modules/queryBuilder/hooks';
import { QueryBuilderActionType } from '@modules/queryBuilder/store/queryBuilderActionType';
import { useQueryBuilderStore } from '@modules/queryBuilder/store/useQueryBuilderStore';
import { FilterListRounded } from '@mui/icons-material';
import { Button, ButtonProps, Tooltip } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { CreateCustomFilterModal } from '../CreateCustomFilterModal';

export const CreateNewFilterButton = ({ ...props }: ButtonProps) => {
  const isCreateNewFilterEnabled = useIsCreateNewFilterEnabled();
  const whereClause = useQueryBuilderStore(
    ({ metadata }) => metadata.whereClause,
  );
  const dispatch = useQueryBuilderStore(({ dispatch }) => dispatch);

  const { openModal, closeModal } = useMuiModalContext();

  if (!isCreateNewFilterEnabled) {
    return null;
  }

  const showCreateNewFilterModal = () => {
    dispatch({
      type: QueryBuilderActionType.SET_METADATA,
      payload: {
        isActive: false,
      },
    });

    openModal({
      contentComponent: () => (
        <CreateCustomFilterModal
          whereClause={whereClause}
          onClose={closeModal}
        />
      ),
      modalProps: {
        fullWidth: true,
        maxWidth: 'md',
      },
    });
    trackCustomFilterEvents({
      eventName: 'Create Custom Filter Button Clicked',
    });
  };

  const renderTooltipText = () => {
    return (
      <CustomFilterInfoText
        typographyProps={{ variant: 'caption' }}
        linkProps={{ target: '_blank', color: 'inherit' }}
      />
    );
  };

  return (
    <CanAccess
      resource={PermissionResource.Artefact}
      operation={PermissionOperation.Write}
    >
      <Tooltip title={renderTooltipText()} arrow>
        <Button
          startIcon={<FilterListRounded />}
          onClick={showCreateNewFilterModal}
          {...props}
        >
          Save as Custom Filter
        </Button>
      </Tooltip>
    </CanAccess>
  );
};
